import { isImage, isVideo, isAudio } from "@/utils/checkFileType.js";

export default {
	methods: {
		isImage,
		isVideo,
		isAudio,

		async generateFileHash(file) {
			const buffer = await file.arrayBuffer();
			const hashBuffer = await crypto.subtle.digest("SHA-256", buffer);
			const hashArray = Array.from(new Uint8Array(hashBuffer));
			return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
		},

		async handleMediaUpload(event, target) {
			const input = event.target;
			if (!input?.files?.[0]) return;

			const file = input.files[0];
			const ext = file.name
				.split(".")
				.pop()
				.toLowerCase();
			const accept = input.accept || "";

			const valid =
				(accept.includes("image") && isImage(ext)) ||
				(accept.includes("audio") && isAudio(ext)) ||
				(accept.includes("video") && isVideo(ext));

			if (!valid) {
				target.isFailed = true;
				target.questionFile = null;
				target.questionMediaType = null;
				target.fileMeta = null;
				return;
			}

			target.isFailed = false;

			// preview
			const reader = new FileReader();
			reader.onload = (e) => {
				target.questionMedia = e.target.result;
			};
			reader.readAsDataURL(file);

			target.questionFile = file;
			target.questionMediaType = ext;

			const hash = await this.generateFileHash(file);
			target.fileMeta = {
				fileName: file.name,
				size: file.size,
				content: hash,
			};

			input.value = "";
		},
	},
};
